import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { PersistGate } from "redux-persist/integration/react";
import TranslationProvider from "../../shared/providers/TranslationProvider";

import withAnalytics from "./Analytics";
import Router from "./Router";
import persistor, { store } from "../../redux/store";
import ScrollToTop from "./ScrollToTop";
import { config as i18nextConfig } from "../../translations";
import AuthProvider from "../../shared/providers/AuthProvider";
import ErrorBoundary from "../../shared/components/ErrorBoundary";
import ServiceStatusBanner from "../../shared/components/ServiceStatusBanner";
import LocalhostApiPanel from "../../dev/LocalhostApiPanel";
import { isLocalhostEnvironment } from "../../dev/apiRequestMonitor";

i18next.init(i18nextConfig);

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<div style={{ padding: 16 }}>Loading…</div>}>
        <I18nextProvider i18n={i18next}>
          <BrowserRouter
            basename="/"
            future={{ v7_relativeSplatPath: true }}
          >
            <ScrollToTop>
              <TranslationProvider>
                <AuthProvider>
                  <ErrorBoundary>
                    <ServiceStatusBanner />
                    <Router />
                    {isLocalhostEnvironment() ? <LocalhostApiPanel /> : null}
                  </ErrorBoundary>
                </AuthProvider>
              </TranslationProvider>
            </ScrollToTop>
          </BrowserRouter>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
